export const useEcho = function () {
    const nuxtApp = useNuxtApp()

    return {
        echo: nuxtApp.$echo,
        echoChannel: nuxtApp.$echoChannel,
    }
};